import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsIconModule } from '@components/icon';
import { CustomPipeModule } from '@components/custom-pipe/custom-pipe.module';
import { LoadingModule } from '@components/loading';
import { TestimonialModule } from '../testimonial/testimonial.module';
import { ReportComponent } from './report.component';
import { SkinParameterModule } from './components/skin-parameter/skin-parameter.module';
import { TreatmentDimensionModule } from './components/treatment-dimension/treatment-dimension.module';
import { ConcernAccordionModule } from './components/concern-accordion/concern-accordion.module';
import { ImprovementJourneyModule } from './components/improvement-journey/improvement-journey.module';
import { HeroIngredientComponent } from './components/hero-ingredients/hero-ingredients.component';
import { RegimenDoctorDetailsCardComponent } from '@shared/regimen-doctor-details-card/regimen-doctor-details-card.component';
import { FloatingVideoPanelComponent } from "@components/floating-video-panel/floating-video-panel.component";
import { RebrandedSkinParameterComponent } from './components/rebranded-skin-parameter/rebranded-skin-parameter.component';
import { ReportTreatmentPlanComponent } from '@shared/report-treatment-plan/report-treatment-plan.component';

@NgModule({
  imports: [
    CommonModule,
    CsIconModule,
    SkinParameterModule,
    TreatmentDimensionModule,
    ConcernAccordionModule,
    ConcernAccordionModule,
    CustomPipeModule,
    LoadingModule,
    TestimonialModule,
    ImprovementJourneyModule,
    HeroIngredientComponent,
    RegimenDoctorDetailsCardComponent,
    FloatingVideoPanelComponent,
    RebrandedSkinParameterComponent,
    ReportTreatmentPlanComponent
],
  declarations: [ReportComponent],
  exports: [ReportComponent],
})
export class ReportModule { }
